var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    stroke: "none",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 15.861 3.677 L 5.882 13.656 C 5.794 13.745 5.673 13.795 5.548 13.795 C 5.422 13.795 5.302 13.745 5.214 13.656 L 0.139 8.582 C 0.05 8.494 0 8.373 0 8.248 C 0 8.122 0.05 8.002 0.139 7.914 L 0.798 7.255 C 0.887 7.165 1.007 7.115 1.133 7.115 C 1.258 7.115 1.378 7.165 1.467 7.255 L 5.543 11.331 L 14.534 2.34 C 14.72 2.16 15.016 2.16 15.202 2.34 L 15.861 3.009 C 15.95 3.097 16 3.218 16 3.343 C 16 3.469 15.95 3.589 15.861 3.677 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9a8d95e21bca855039c55696053ec347.svg";
export { ForwardRef as ReactComponent };